import { LogoutOutlined, SettingOutlined } from '@ant-design/icons';
import { Dropdown } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'src/constants/routes';
import { getAuth } from 'src/redux/slices/auth';
import AvatarEmpty from 'src/screens/shared/components/AvatarEmpty';
import ChevronDownIcon from 'src/screens/shared/components/ChevronDownIcon';
import { AvatarCustom } from 'src/screens/shared/Styles';

type Props = {
  onLogout: () => void;
};

const CurrentUser = ({ onLogout }: Props) => {
  const { t } = useTranslation();
  const { currentUser, superAdminUser } = useSelector(getAuth);
  const navigate = useNavigate();

  const userMenuItems = [
    {
      key: 'settings',
      icon: <SettingOutlined />,
      label: t('profileScreen:page_title'),
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: t('layout:logout'),
    },
  ];

  const handleUserMenuClick = ({ key }) => {
    if (key === 'settings') {
      navigate(ROUTES.PROFILE);
    } else if (key === 'logout') {
      onLogout();
    }
  };

  return (
    <>
      {superAdminUser && !currentUser ? (
        <Dropdown
          menu={{
            items: userMenuItems,
            onClick: handleUserMenuClick,
          }}
          trigger={['click']}
          placement="bottomRight"
        >
          <div className="user-dropdown">
            <div className="user-info">
              <span>{`${superAdminUser?.first_name} ${superAdminUser?.last_name}`}</span>
              <span className="user-role">Super admin</span>
            </div>
            <ChevronDownIcon style={{ backgroundColor: '#fff' }} />
          </div>
        </Dropdown>
      ) : superAdminUser ? (
        <div className="user-info">
          <span>{`${superAdminUser?.first_name} ${superAdminUser?.last_name}`}</span>
          <span className="user-role">Super admin</span>
        </div>
      ) : null}

      {superAdminUser && currentUser ? <div className="user-separator" /> : null}

      {currentUser ? (
        <Dropdown
          menu={{
            items: userMenuItems,
            onClick: handleUserMenuClick,
          }}
          trigger={['click']}
          placement="bottomRight"
        >
          <div className="user-dropdown">
            {currentUser?.avatar ? (
              <AvatarCustom src={currentUser.avatar} />
            ) : (
              <AvatarEmpty
                char1={currentUser?.first_name.charAt(0) || ''}
                char2={currentUser?.last_name.charAt(0) || ''}
              />
            )}
            <div className="user-info">
              <span>{`${currentUser?.first_name} ${currentUser?.last_name}`}</span>
              <span className="user-role">{currentUser?.role.name}</span>
            </div>
            <ChevronDownIcon style={{ backgroundColor: '#fff' }} />
          </div>
        </Dropdown>
      ) : null}
    </>
  );
};

export default CurrentUser;
